export class LiveTemplateFormApi {
  constructor(util) {
    this.util = util;
  }
  copyTemplateForm(formId, projectId, copyProjectId, formName) {
    return this.util.post(`/api/2/projects/${projectId}/forms`, {
      name: formName,
      copyProjectId,
      copyFormId: formId.toString()
    });
  }
  createTemplateFormForProject(projectId, formName) {
    return this.util.post(`/api/2/projects/${projectId}/forms`, {
      name: formName
    });
  }
}